import React, {useEffect, useState} from "react";
import * as Yup from "yup";
import {makeRequired, makeValidate} from "mui-rff";
import classnames from "classnames";
import Form from "../../../../base/form";
import {Fade, SvgIcon} from "@mui/material";
import IconButton from "../../../../base/button/icon_button";
import {Edit} from "@mui/icons-material";
import {ReactComponent as RemoveIcon} from "../../../../../../assets/images/remove.svg";
import {OutlinedInputForm} from "../../../../base/input/outlined_input";
import SaveOrRollback from "../../../save-or-rollback";

const schema = Yup.object().shape({
    title: Yup.string().nullable().required(),
})

const subscription = {submitting: true, values: true, initialValues: true};


const WarrantyAndReturnExtraFeesTitleCard = ({title, update, remove}) => {
    const [editing, setEditing] = useState(false)
    const [initialValues, setInitialValues] = useState({})
    const validate = makeValidate(schema)
    const required = makeRequired(schema)

    /**
     * Listens to the changes in the title and with each change:
     * sets the initialValues of the form.
     */
    useEffect(() => {
        setInitialValues({
            title: title?.title ?? '',
        })
    }, [title])


    /**
     * Prepares the new version of the title to be sent through api and then based on the returned resultFlag,
     * remains in or gets out of the edit mode.
     * @param {mode} values formValues
     */
    const updateTitle = (values) => {
        if (values.title === title.title) {
            setEditing(false)
            return
        }
        const newTitle = {
            ...title,
            title: values.title,
        }
        update(newTitle).then(resultFlag => resultFlag && setEditing(false))
    }

    /**
     * Reverts the values of this template.
     * @param {any} values
     * @param {formApi} form
     */
    const revertValues = (values, form) => {
        setEditing(false)
        form.reset(initialValues)
    }

    /**
     * Gets users confirmation before removing the current entity.
     */
    const getRemoveConfirmation = () => {
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Are you sure, you want to remove this title?
                </p>
            </div>,
            {
                maxWidth: 'sm'
            },
            (confirmed) => confirmed && remove(title),
        );
    }

    return (
        <>
            <div className={classnames('extra-fees-title-card', {'editing': editing})}>
                <Form
                    className={''}
                    onSubmit={() => false}
                    subscription={subscription}
                    validate={validate}
                    initialValues={initialValues}
                    render={({values, form}) => {
                        return (
                            <>
                                <div className={'d-flex flex-column'}>
                                    <div className={'d-flex justify-content-end align-items-center'}>
                                        <Fade in={!editing} className={"mx-1 ml-2"}>
                                            <IconButton
                                                disabled={title.editing || editing}
                                                color={'paper.secondary'}
                                                onPressed={() => setEditing(true)}
                                            >
                                                <Edit className={"icon normal"}/>
                                            </IconButton>
                                        </Fade>
                                        <IconButton
                                            onPressed={getRemoveConfirmation}
                                            disabled={title?.editing}
                                            color={'paper.error'}
                                        >
                                            <SvgIcon component={RemoveIcon} className='icon normal'/>
                                        </IconButton>
                                    </div>
                                    <div className={classnames('fade-container', {
                                        'expanded': editing,
                                    })}>
                                        <Fade in={editing}
                                              className={'d-flex justify-content-between align-items-center'}>
                                            <div>
                                                <OutlinedInputForm
                                                    name={'title'}
                                                    placeholder={'title'}
                                                    label={"Title"}
                                                    multiline
                                                    className={'mr-2 max-w-80'}
                                                    required={required.title}
                                                    value={values.title ?? ''}
                                                    onChange={(e) => form.change(e.target.name, e.target.value)}
                                                />
                                                <SaveOrRollback
                                                    column={false}
                                                    loading={title.editing}
                                                    show={true}
                                                    onRollback={() => revertValues(values, form)}
                                                    onSave={() => updateTitle(values)}
                                                />
                                            </div>
                                        </Fade>
                                        <Fade in={!editing} className={'d-flex'}>
                                            <div>
                                                <p className={'title'}>
                                                    {title?.title ?? ''}
                                                </p>
                                            </div>
                                        </Fade>
                                    </div>
                                </div>
                            </>
                        );
                    }}
                />
            </div>
        </>
    );
}

export default WarrantyAndReturnExtraFeesTitleCard;
